import Splide from '@splidejs/splide';
import { unitlessBreakpoints } from '@/scripts/helpers/breakpoints';

const selectors = {
  testimonialCarousel: '[data-testimonial-carousel-slider]',
};

export default class DynamicTestimonials {
  constructor(section) {
    this.section = section;
    this.carousels = [];

    this.initTestimonialCarousel();
  }

  initTestimonialCarousel() {
    const carouselElements = this.section.el.querySelectorAll(
      selectors.testimonialCarousel,
    );

    this.carousels = [...carouselElements].map(carousel => {
      const testimonialCarousel = new Splide(carousel, {
        type: 'loop',
        autoplay: true,
        interval: 5000,
        pauseOnHover: true,
        arrows: false,
        perPage: 1,
        perMove: 1,
        gap: '1rem',
        mediaQuery: 'min',
        breakpoints: {
          [unitlessBreakpoints.md]: {
            perPage: 2,
          },
          [unitlessBreakpoints.lg]: {
            perPage: 3,
          },
        },
      });

      testimonialCarousel.mount();

      return testimonialCarousel;
    });
  }

  onSectionUnload() {
    this.carousels.forEach(carousel => carousel.destroy());
    this.carousels = [];
  }
}
